import Vue from "vue";
import VueRouter from "vue-router";
import Vue2Editor from "vue2-editor";
import Home from "../views/Home.vue";
import Login from "@/components/Login.vue";
// import Dashboard from "@/components/Dashboard.vue";

// Cedulas
const Oficialia = () => import("@/views/oficialia/oficialia.vue");

// Partes
const Partes = () => import("@/views/Partes/Partes.vue");
const Show = () => import("@/views/Partes/Show.vue");
const PartesTocas = () => import("@/views/Partes/Tocas.vue");


const ParteSinValidar = () => import("@/views/Partes/SinValidar.vue");
const BuscarPartes = () => import("@/views/Partes/BuscarPartes.vue");

// Tocas
const TocasList = () => import("@/views/tocas/list.vue");


const Roles = () => import("@/views/roles/roles.vue");
const Users = () => import("@/views/Users/User.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Logs = () => import("@/views/logs/log.vue");
const Notificaciones = () => import("@/views/Partes/Notificaciones.vue");

const Dashboard = () => import("@/views/dashboard/index.vue");


Vue.use(VueRouter);
Vue.use(Vue2Editor);
/*ROLES
  1 =>  SUPER-ADMIN
  2 =>  ADMIN DEPENDENCIA
  3 =>  OFICIALIA
  4 =>  ADMIN SEC ACUERDOS
  5 =>  NOTIFICADORES

  CHECAR QUE COICINDAN CON LOS ASIGNADOS EM EL BACKEND
*/
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { authorize: [1, 2] }
  },
  // Cedulas
  {
    path: "/oficialia",
    name: "Oficilia",
    component: Oficialia,
    meta: { authorize: [1, 2] }
  },



  // Partes
  {
    path: "/buscar-partes",
    name: "BuscarPartes",
    component: BuscarPartes,
    meta: { authorize: [1,2,3,4] }
  },
  // Partes Sin Validar las que no estan Validadadas por cedulas (unicamnete para 8 sala)
  // {
  //   path: "/partesinvalidar",
  //   name: "ParteSinValidar",
  //   component: ParteSinValidar,
  //   meta: { authorize: [1, 4] }
  // },

  {
    path: "/partes",
    name: "Partes",
    component: Partes,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/partes/show/:id",
    name: "Show",
    component: Show,
    props: true,
    meta: { authorize: [1, 2, 3, 4] }
  },

  {
    path: "/partes/:parte_id/tocas",
    name: "PartesTocas",
    component: PartesTocas,
    props: true,
    meta: { authorize: [1, 2, 3, 4] }
  },

  // Tocas
  {
    path: "/tocas",
    name: "Tocas",
    component: TocasList,
    props: true,
    meta: { authorize: [1, 2, 4, 5] }
  },


  // Notificaciones
  {
    path: "/notificaciones/:toca_id",
    name: "Notificaciones",
    component: Notificaciones,
    props: true,
    meta: { authorize: [1, 2, 4, 5] }
  },

  // Users

  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/user/editPassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4] }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/logs",
    name: "Logs",
    component: Logs,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4, 5] }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));

  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.role_id)) {
      // Si es notificador
      if(userLogged.role_id == 5){
        return next({ path: "/tocas" });
      }
      return next({ path: "/buscar-partes" });
    }
  }
  if ((to.path === "/" || to.path === "/login") && userLogged) {
    if(userLogged.role_id == 5){
      return next({ path: "/tocas" });
    }
    return next({ path: "/buscar-partes" });
  }
  next();
});

export default router;
